/**
 * @component sg-print-page - Directive which can be placed on any page to print.
 *                            sg-print-page directive uses the MD styling.
 *
   Usage:
   <sg-print-page></sg-print-page>
 */

'use strict';

(() => {
  angular
    .module('specsguardApp')
    .directive('sgPrintPage', sgPrintPage);

  function sgPrintPage () {
    return {
      templateUrl: 'app-legacy/components/sg-print-page/sg-print-page.html',
      restrict: 'E',
      controller: 'sgPrintPageController',
      controllerAs: 'sgPrintPageCtrl'
    };
  };
})();
